// Thông tin pháp nhân vận hành Bói Đê — NGUỒN DUY NHẤT cho footer, trang pháp lý và JSON-LD.
// Đổi pháp nhân (hoặc rollback) chỉ cần sửa file này: các trường `null` tự động ẩn khỏi UI
// và các câu trong trang pháp lý tự đổi kênh liên hệ theo `email`.

export type BusinessInfo = {
  /** Tên pháp nhân hiển thị công khai. */
  readonly name: string;
  /** Nhãn tiêu đề khối thông tin ở footer (công ty / cá nhân kinh doanh / đơn vị vận hành). */
  readonly blockLabel: string;
  /** Mã số thuế — `null` để không công bố. */
  readonly taxCode: string | null;
  /** Website pháp nhân, không kèm protocol — `null` để không công bố. */
  readonly website: string | null;
  /** Email liên hệ — `null` để không công bố, khi đó dùng `supportChannel`. */
  readonly email: string | null;
  /** Kênh hỗ trợ thay thế khi không công bố email. */
  readonly supportChannel: string;
};

/** Pháp nhân hiện tại. */
export const BUSINESS_INFO: BusinessInfo = {
  name: "Cá nhân kinh doanh",
  blockLabel: "Đơn vị vận hành",
  taxCode: null,
  website: null,
  email: "boide@bioselai.com",
  supportChannel: "mục Hộp thư trong ứng dụng",
};

// ROLLBACK về pháp nhân cũ: thay giá trị của BUSINESS_INFO ở trên bằng khối dưới đây.
// {
//   name: "BIOSEL AI COMPANY LIMITED",
//   blockLabel: "Thông tin công ty",
//   taxCode: "0319088471",
//   website: "bioselai.com",
//   email: "boide@bioselai.com",
//   supportChannel: "mục Hộp thư trong ứng dụng",
// }

/** Cụm từ chỉ kênh liên hệ, dùng chèn giữa câu: "liên hệ qua {CONTACT_CHANNEL}". */
export const CONTACT_CHANNEL: string = BUSINESS_INFO.email
  ? `email ${BUSINESS_INFO.email}`
  : BUSINESS_INFO.supportChannel;

/** Phần đuôi tuỳ chọn bổ sung email vào câu đã nêu sẵn kênh Hộp thư. */
export const CONTACT_EMAIL_SUFFIX: string = BUSINESS_INFO.email
  ? ` hoặc email ${BUSINESS_INFO.email}`
  : "";
